import { classNames } from "@/utils/strings";

export const getItemClassName = (
  isActive: boolean,
  extraClasses: string = "",
) => {
  return classNames(
    isActive
      ? "bg-gray-200 text-black hover:text-gray-900"
      : "font-normal text-gray-800 hover:bg-gray-50 hover:text-gray-900",
    extraClasses,
  );
};
